(function($)
{
    $.fn.msxiTableDnDAjaxReorder = function(options)
    {
        var opts = $.extend(true, {}, $.fn.msxiTableDnDAjaxReorder.defaults, options);
        var otherOnDrop = opts.tableDnD.onDrop;

        return this.each(function()
        {
            opts.tableDnD.onDrop = function(table, row)
            {
                if (opts.ajaxReorderUrl)
                {
                    var serialized = $.tableDnD.serialize();
                    $.post(opts.ajaxReorderUrl + (opts.ajaxReorderUrl.indexOf("?")>0?"&":"?") + serialized, {}, function(data)
                    {
                        if (data.success)
                        {
                            $(table).siblings(".tabledndSuccess:first").fadeIn(800, function(){ $(this).fadeTo(2000, 1).fadeOut(800); });
                        }
                        else
                        {
                            // TODO on error we could rearrange the table to the order given to make sure it still reflects the current state
                            $(table).siblings(".tabledndError:first").fadeIn(800);
                        }
                        if (opts.onAjaxData)
                        {
                            (opts.onAjaxData)(table, row, data);
                        }
                    }, "json");
                }
                if (otherOnDrop)
                {
                    (otherOnDrop)(table, row);
                }
            };
            $(this).tableDnD(opts['tableDnD']);
        });
    };

    $.fn.msxiTableDnDAjaxReorder.defaults =
    {
        ajaxReorderUrl: null,
        onAjaxData: null,
        tableDnD:
        {
            onDragClass: "dragging"
        }
    };
})(jQuery);